import { FaHtml5, FaCss3, FaNodeJs, FaReact, FaSass, FaFigma, FaPhoneAlt, FaUser, FaMapMarkerAlt, FaPaperPlane, FaDribbble, FaInstagram, FaLinkedin, FaFacebookSquare, FaGithub } from "react-icons/fa";
import { DiJavascript } from "react-icons/di";
import { SiTypescript } from "react-icons/si";
import { BsMedium } from "react-icons/bs";
// import portfolio from "./assets/portfolio.jpg"
import boidekho1 from "./assets/boidekho/pic1.png";
import boidekho2 from "./assets/boidekho/pic2.png";
import boidekho3 from "./assets/boidekho/pic3.png";
import boidekho4 from "./assets/boidekho/pic-4.png";
import boidekho5 from "./assets/boidekho/pic-5.png";
import boidekho6 from "./assets/boidekho/pic6.png";
import boidekho7 from "./assets/boidekho/pic-7.png";

import dreamcar1 from "./assets/dream-car/pic1.png";
import dreamcar2 from "./assets/dream-car/pic2.png";
import dreamcar3 from "./assets/dream-car/pic-3.png";
import dreamcar4 from "./assets/dream-car/pic-4.png";
import dreamcar5 from "./assets/dream-car/pic-5.png";
import dreamcar6 from "./assets/dream-car/pic-6.png";
import dreamcar7 from "./assets/dream-car/pic-7.png";

import ticket1 from "./assets/ticket/pic1.png";
import ticket2 from "./assets/ticket/pic2.png";
import ticket3 from "./assets/ticket/pic3.png";
import ticket4 from "./assets/ticket/pic4.png";
import ticket5 from "./assets/ticket/pic5.png";

import todoapp1 from "./assets/todo-app/pic-1.png";

import telesitter1 from "./assets/telessitter/pic1.png";
import telesitter2 from "./assets/telessitter/pic2.png";

import argun1 from "./assets/arjun/pic1.png";
import argun2 from "./assets/arjun/pic2.png";
import argun3 from "./assets/arjun/pic-3.png";

import nextTail1 from "./assets/next14-Tail/pic1.png";
import nextTail2 from "./assets/next14-Tail/pic2.png";

import handy1 from "./assets/handy/pic1.png";
import handy2 from "./assets/handy/pic2.png";

import sorting1 from "./assets/algo/pic1.png";
import sorting2 from "./assets/algo/pic2.png";
import sorting3 from "./assets/algo/pic3.png";

import phpmeal1 from "./assets/php-meal/pic1.png";
import phpmeal2 from "./assets/php-meal/pic2.png";
import phpmeal3 from "./assets/php-meal/pic3.png";

import phpattan1 from "./assets/php-attandance/pic1.png";
import phpattan2 from "./assets/php-attandance/pic2.png";
import phpattan3 from "./assets/php-attandance/pic3.png";


export const navLinks = ["home", "about", "skills", "portfolio", "contact"]

export const socialIcons = [
  {
    icon:<FaFacebookSquare />,
    link: "https://www.facebook.com/ashanaur.rahman.16"
  },
  {
    icon:<FaGithub />,
    link: "https://github.com/DEV-ASHANAUR"
  },
  {
    icon:<FaLinkedin />,
    link: "https://www.linkedin.com/in/md-ashanaur-rahman-117bba21a/"
  }
]

export const bios = [
  {
    id: 1,
    icon: <FaUser />,
    key: "Name",
    value: "Md.Ashanaur Rahman"
  },
  {
    id: 2,
    icon: <FaPhoneAlt />,
    key: "Phone",
    value: "0186696562"
  },
  {
    id: 3,
    icon: <FaPaperPlane />,
    key: "Email",
    value: "ashanour009@gmail.com"
  }
]

export const icons = [<FaHtml5 />, <FaCss3 />, <DiJavascript />, <SiTypescript />, <FaReact />, <FaNodeJs />, <FaSass />, <FaFigma />]

export const experiences = [
  {
    id: 1,
    year: "2021-Running",
    position: "BSC in CSE",
    company: "Green University of Bangladesh"
  },
  {
    di: 2,
    year: "2020",
    position: "Diploma in Computer Science And Technology",
    company: "Faridpur Polytechnic Institute"
  },
  {
    id: 3,
    year: "2016",
    position: "Secondary School Certificate (SSC)",
    company: "Rajbari Govt. High School"
  }
]
export const finishes = [
  {
    id: 1,
    number: '3+',
    itemName: "Years Of Coding Experience"
  },
  // {
  //   id: 2,
  //   number: "150+",
  //   itemName: "Satisfied Customers"
  // },
  // {
  //   id: 3,
  //   number: "669+",
  //   itemName: "Designed Items"
  // },
  // {
  //   id: 4,
  //   number: "117+",
  //   itemName: "Clients Served"
  // }
]
export const workImages = [
  
  {
    id: 1,
    img: [boidekho1,boidekho2,boidekho3,boidekho4,boidekho5,boidekho6,boidekho7],
    details:['View a comprehensive list of books with details such as title, author, publisher, and category.','Filter books by author, publisher, and category to easily find specific books.','Enjoy a seamless user experience on various devices and screen sizes.','Utilizes Firebase for backend services, including real-time data updates and authentication.','Rest api service using node js, express js and mongoose'],
    client:"https://github.com/DEV-ASHANAUR/boi-dekho-client",
    server:"https://github.com/DEV-ASHANAUR/boi-dekho-server",
    live_link: "https://boikini-cc2db.web.app/",
    is_live:true,
    name: "E-Commerce - BOI-DEKHO.COM",
    tech:["html","css","bootstrap","react js","express js","mongoose","redux toolkit"],
    category: "mern"
  },
  {
    id: 2,
    img: [ticket1,ticket2,ticket3,ticket4,ticket5],
    details:['Customer Can Buy Bus Ticket By Using This WebSite,','Customer can search bus by from to target destination','after complete ticket purchase customer can view his ticket','For storing data we used mongoose and monogodb','Rest api service using node js, express js and mongoose'],
    client:"https://github.com/DEV-ASHANAUR/bus-ticket-buy-system---react",
    server:"https://github.com/DEV-ASHANAUR/bus-ticket-api",
    live_link: "https://preeminent-tulumba-1b0a47.netlify.app/",
    is_live:true,
    name: "Ticket Buying - Bus Ticket",
    tech:["html","css","bootstrap","react js","express js","mongodb"],
    category: "mern"
  },
  {
    id: 3,
    img: [nextTail1,nextTail2],
    details:['**Next.js Framework:** Utilizes the Next.js framework for efficient server-side rendering and optimal performance.','Tailwind CSS Integration:** Leverages Tailwind CSS for utility-first styling and easy customization.','Responsive Design:** Ensures a seamless and visually appealing experience across various devices and screen sizes.','Easy Customization:** Customize the landing page content, colors, and styles effortlessly to match your brand or project requirements.'],
    client:"https://github.com/DEV-ASHANAUR/next-14-tailwind-landing-page",
    // server:"https://github.com/DEV-ASHANAUR/dream-car-server",
    live_link: "https://next-14-tailwind-landing-page.vercel.app/",
    is_live: true,
    name: "Next14 tailwind - Landing page",
    tech:["reactjs","tailwind","nextjs"],
    category: "frontend"
  },
  {
    id: 4,
    img: [telesitter1,telesitter2],
    details:['React Components:** Utilizes the power of React.js to create modular and reusable components for easy customization.,','Bootstrap Integration: Seamless integration of Bootstrap components for a responsive and mobile-friendly layout.','Modern Design:** Incorporates contemporary design trends and UI elements for a polished appearance.','Customization:** Easily customize the landing page content, colors, and styling to suit your brand or project requirements.','Responsive Layout:** Ensures a consistent and user-friendly experience across various devices and screen sizes.'],
    client:"https://github.com/DEV-ASHANAUR/telesitters",
    // server:"https://github.com/DEV-ASHANAUR/dream-car-server",
    live_link: "https://effervescent-raindrop-6c43b4.netlify.app/",
    is_live: true,
    name: "Telesitters - Landing page",
    tech:["html","bootstrap","react js"],
    category: "frontend"
  },
  {
    id: 5,
    img: [todoapp1],
    details:['Task Creation: Easily create new tasks with a title.,','Status Tracking: Assign status labels such as "To-Do," "In Progress," and "Completed" to tasks.','Filtering: Quickly filter tasks based on their status for better organization.','User-Friendly Interface: Intuitive design for a seamless task management experience.'],
    client:"https://github.com/DEV-ASHANAUR/redux-todo-app",
    // server:"https://github.com/DEV-ASHANAUR/dream-car-server",
    live_link: "https://willowy-biscochitos-3d8dc5.netlify.app/",
    is_live: true,
    name: "Todo App - redux learning",
    tech:["html","tailwind","react js","json-server"],
    category: "frontend"
  },
  {
    id: 6,
    img: [handy1,handy2],
    details:['React Components:** Utilizes the power of React.js to create modular and reusable components for easy customization.,','Bootstrap Integration: Seamless integration of Bootstrap components for a responsive and mobile-friendly layout.','Modern Design:** Incorporates contemporary design trends and UI elements for a polished appearance.','Customization:** Easily customize the landing page content, colors, and styling to suit your brand or project requirements.','Responsive Layout:** Ensures a consistent and user-friendly experience across various devices and screen sizes.'],
    client:"https://github.com/DEV-ASHANAUR/school-handy",
    // server:"https://github.com/DEV-ASHANAUR/dream-car-server",
    live_link: "https://cerulean-manatee-8f55e4.netlify.app/",
    is_live: true,
    name: "School handy - Landing page",
    tech:["html","bootstrap","react js"],
    category: "frontend"
  },
  {
    id: 7,
    img: [argun1,argun2,argun3],
    details:['React Components:** Utilizes the power of React.js to create modular and reusable components for easy customization.,','Bootstrap Integration: Seamless integration of Bootstrap components for a responsive and mobile-friendly layout.','Modern Design:** Incorporates contemporary design trends and UI elements for a polished appearance.','Customization:** Easily customize the landing page content, colors, and styling to suit your brand or project requirements.','Responsive Layout:** Ensures a consistent and user-friendly experience across various devices and screen sizes.'],
    client:"https://github.com/DEV-ASHANAUR/arjun-react-theme",
    // server:"https://github.com/DEV-ASHANAUR/dream-car-server",
    live_link: "https://delicate-frangollo-03d133.netlify.app/",
    is_live: true,
    name: "Arjun G - Landing page",
    tech:["html","bootstrap","react js"],
    category: "frontend"
  },
  {
    id: 8,
    img: [dreamcar1,dreamcar2,dreamcar3,dreamcar4,dreamcar5,dreamcar6,dreamcar7],
    details:['Customer Can Buy Any Type of Car By Using This WebSite,','Customer Can Review us','Server site accept user requst and fetch data or insert data to the database.','For storing data we used monogodb','Rest api service using node js, express js and mongoose'],
    client:"https://github.com/DEV-ASHANAUR/dream-car-client",
    server:"https://github.com/DEV-ASHANAUR/dream-car-server",
    live_link: "https://warm-youtiao-a5e05c.netlify.app/",
    is_live: true,
    name: "Car-selling - DREAMCAR",
    tech:["html","css","bootstrap","react js","express js","mongodb"],
    category: "mern"
  },
  {
    id: 9,
    img: [sorting1,sorting2,sorting3],
    details:['The Main objective of Sorting Visualizer project is to learn and visualize the sorting algorithms how these algorithms works.','We can see the steps of swapping or any divide and conquer part of these bars.','Here five different types of sorting algorithms are used to visualize.','A visualization of data is implemented as a bar graph.'],
    client:"https://github.com/DEV-ASHANAUR/sorting-visualizer",
    live_link: "https://verdant-gumdrop-561aca.netlify.app/",
    is_live: true,
    name: "Sorting Visualizer",
    tech:["html","css","bootstrap","algorithms-and-data-structures"],
    category: "algorithm"
  },
  {
    id: 10,
    img: [phpmeal1,phpmeal2,phpmeal3],
    details:['Secure login and registration system for hostel residents and administrators.','Different access levels for residents and administrators.','Daily, weekly, and monthly meal consumption reports.','Monitor can manage resident profiles, meal preferences, and allocations','Comprehensive statistics and reports on meal consumption.','Mobile-friendly design for accessibility on various devices.'],
    client:"https://github.com/DEV-ASHANAUR/meal-management-system",
    live_link: "sorry! domain expired!",
    is_live: false,
    name: "Meal Management System",
    tech:["html","css","bootstrap","php","mysqli"],
    category: "php"
  },
  {
    id: 11,
    img: [phpattan1,phpattan2,phpattan3],
    details:['User Authentication: Secure login system for teachers, students, and administrators.','Real-time Attendance Tracking: Teachers can mark attendance in online, and students can view their attendance records.','Reporting and Analytics'],
    client:"https://github.com/DEV-ASHANAUR/attendance-management-system",
    live_link: "sorry! domain expired!",
    is_live: true,
    name: "Attandance Management Systems",
    tech:["html","css","bootstrap","php","mysqli"],
    category: "php"
  },
  
]


export const workNavs = [
  "All", "FRONTEND", "MERN", "PHP","ALGORITHM"
]

export const contacts = [
  {
    id: 1,
    icon: <FaMapMarkerAlt />,
    infoText: "16 Road, TharKayTa , Yangon"
  },
  {
    id: 2,
    icon: <FaPaperPlane />,
    infoText: "abee02@gmail.com"
  },
  {
    id: 3,
    icon: <FaPhoneAlt />,
    infoText: "+959-883-271-929"
  }
]
